import React, { Component } from 'react';
import './index.less';
class Footer extends Component {
    render() {
        return (
            <div className='footer'>
                版权所有 布里特安防公司&copy;  (推荐使用chrome 浏览器达到极致体验 ) 
            </div>
        );
    }
}

export default Footer;